import { Button, Container, Flex, Image, Text, Title } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { IconHome } from "@tabler/icons-react";

import logo from "../assets/logo-02-cropped.svg";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <Container size="md">
      <Flex
        direction="column"
        align="center"
        justify="center"
        h="100vh"
        gap="xl"
      >
        <Image
          src={logo}
          alt="Congrs Logo"
          style={{ maxWidth: "250px" }}
          mb="md"
        />

        <Flex direction="column" align="center" gap="md">
          <Title
            order={1}
            style={{
              fontSize: "6rem",
              fontWeight: 900,
              color: "var(--mantine-color-gray-3)",
            }}
          >
            404
          </Title>

          <Title order={2} ta="center">
            Page Not Found
          </Title>

          <Text size="lg" c="dimmed" ta="center" maw={500}>
            The page you are looking for might have been removed, had its name
            changed, or is temporarily unavailable.
          </Text>
        </Flex>

        <Button
          size="md"
          leftSection={<IconHome size={20} />}
          onClick={() => navigate("/app")}
          variant="outline"
        >
          Go to Homepage
        </Button>
      </Flex>
    </Container>
  );
}
